import React, { useEffect, useState } from 'react'

import { autoLogin } from '../Functions'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import heroImage from '../assets/heroimage.png'

import card_image_1 from '../assets/icons/Group 22249.svg'
import card_image_2 from '../assets/icons/Group 22250.svg'
import card_image_3 from '../assets/icons/Group 22260.svg'
import card_image_4 from '../assets/icons/Group 22252.svg'

import why_image_1 from '../assets/icons/Group 22245.svg'
import why_image_2 from '../assets/icons/Group 22244.svg'
import why_image_3 from '../assets/icons/Group 22246.svg'
import why_image_4 from '../assets/icons/Group 22247.svg'

import netflix_logo from '../assets/Group 22348.png'
import binance_logo from '../assets/Group 22349.png'
import bolt_logo from '../assets/Group 22350.png'
import playstation_logo from '../assets/Group 22347.png'

import appstore from '../assets/icons/bdcdd5a2a73e4b0e9334081f5e61c648.svg'
import huawei from '../assets/icons/huawei-appgallery-2.svg'
import apk from '../assets/icons/f410f5f4e93b55064cff5d0fc479225b.svg'



export default function Home() {

    const [showSearch, setShowSearch] = useState(false)
    const [searchValue, setSearchValue] = useState("")

    function showSearchButton(value) {
        if(value===""){
            setShowSearch(false)
        }else{
            setSearchValue(value)
            setShowSearch(true)
        }
       
        
    }

    function CallSearchHome(){
        window.location.href=`/products?search=${searchValue}`
    }

    useEffect(() => {
        autoLogin()
    }, [])

    return (
        <>
            <Navbar />
            <section  className='hero_section d-flex flex-column justify-content-center align-items-center' >
                <div id='hero' className='container bg_grey  br_25 ' >
                    <div className='row'>

                        <div className='col-md-8 d-flex flex-column justify-content-center p-10'>

                            <h2 style={{ fontWeight: 'lighter' }} >Find the <span className='bold' >Perfect </span> <br></br>
                                <span className='primary_purple bold' >E-Voucher</span> for Every <br></br>Need with Giftbox</h2>

                            <p className='light mt-1' >Giftbox offers 17,000+ vouchers and discounts from top <br></br>
                                brands like Amazon, Netflix, Sephora, and more. Find <br></br>
                                deals on eSIMs, gaming, travel, retail, and <br></br>
                                entertainment in 190+ countries.</p>


                            <div className="search-input-home mt-2">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    style={{ paddingLeft: '30px' }}
                                    onChange={(event) => showSearchButton(event.target.value)} />


                                    {showSearch ?
                                <button
                                    style={{ borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px', fontSize: '1.3rem' }}
                                    className='btn bg_purple_light primary_purple bold' 
                                    onClick={() => CallSearchHome()}>Search</button> : ""}

                            </div>
                        </div>

                        {/* <div className='col-md-1 d-flex justify-content-center align-items-center'>
                            <img src={dashedBackground} style={{ zIndex: 3 }} />
                        </div> */}

                        <div className="col-md-4 p-0" >
                            <div className='home_vouchers_hover br_25' style={{ backgroundImage: `url(${heroImage})` }}>

                            </div>
                        </div>


                    </div>
                </div>
            </section>


            <section data-aos="fade-up"
                className="w3-container w3-center w3-animate-top py-5 mb-5 fade-in">
                <div className="container">
                    <h2 className="">Categories</h2>

                    <div className="mt-5">
                        <div className="row">
                            <div className="col-lg-3   col-sm-6 mb-4">

                                <div data-aos="flip-right" data-aos-duration="1000"
                                    className="home_category">
                                    <img src={card_image_1} className="img-fluid" alt="dift voucher"/>
                                    <div>
                                        <h3>Gift Voucher</h3>
                                        <p className='light' >Explore top brand vouchers <br></br> for every special occasion.</p>
                                    </div>
                                    <button className="home_button_purple" onClick={() => window.location.href = '/products'}>View Vouchers</button>
                                </div>
                            </div>

                            <div className="col-lg-3   col-sm-6 mb-4">
                                <div data-aos="flip-right" data-aos-duration="1000"
                                    className="home_category ">
                                    <img src={card_image_2} className="img-fluid" alt="mobile data"/>
                                    <div>
                                        <h3>Mobile Data</h3>
                                        <p className='light' >Stay connected with <br></br>flexible mobile data plans.</p>
                                    </div>
                                    <button className="home_button_purple" onClick={() => window.location.href = '/products?service=1'}>View Vouchers</button>
                                </div>
                            </div>

                            <div className="col-lg-3   col-sm-6 mb-4">
                                <div data-aos="flip-right" data-aos-duration="1000"
                                    className="home_category ">
                                    <img src={card_image_3} className="img-fluid" alt="utilities card"/>
                                    <div>
                                        <h3>Utilities</h3>
                                        <p className='light' >Manage and pay your <br></br> essential utility bills easily.</p>
                                    </div>
                                    <button className="home_button_purple" onClick={() => window.location.href = '/products?service=3'}>View Vouchers</button>
                                </div>
                            </div>

                            <div className="col-lg-3   col-sm-6 mb-4">
                                <div data-aos="flip-right" data-aos-duration="1000"
                                    className="home_category ">
                                    <img src={card_image_4} className="img-fluid" alt="esim" />
                                    <div>
                                        <h3>E-Sim</h3>
                                        <p className='light' >Enjoy instant and seamless <br></br> connectivity with eSIM.</p>
                                    </div>
                                    <button className="home_button_purple" onClick={() => window.location.href = '/products?service=13'}>View Vouchers</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


            <section data-aos="fade-up" className="animate__animated animate__fadeIn bg_purple_light py-12">
                <div data-aos="zoom-in" className="container ">
                    <h2>Why Giftbox?</h2>
                    <p className='mt-2 light' >
                        Whether you're a frequent traveler, a gamer, or someone who just <br />
                        loves shopping, Giftbox offers the ultimate flexibility and value. Start <br />
                        exploring our marketplace today and enjoy endless opportunities!
                    </p>

                    <div className="mt-7">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12">

                                <div data-aos="zoom-in" className="why_cards ">
                                    <img src={why_image_1} className="img-fluid" alt="variety"/>
                                    <div >
                                        <h3>Wide Variety</h3>
                                        <p className='light'>Access vouchers across diverse <br></br>
                                            categories for all your needs.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div data-aos="zoom-in" className="why_cards ">
                                    <img src={why_image_2} className="img-fluid" alt="global vouchers" />
                                    <div>
                                        <h3>Global Reach</h3>
                                        <p className='light'>Redeem or send vouchers <br></br> in 190+ countries worldwide.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12 ">
                                <div data-aos="zoom-in" className="why_cards ">
                                    <img src={why_image_3} className="img-fluid" alt="brands"/>
                                    <div>
                                        <h3>Top Brands</h3>
                                        <p className='light'>Enjoy offers from globally <br></br> recognized brands.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div data-aos="zoom-in" className="why_cards ">
                                    <img src={why_image_4} className="img-fluid" alt="satisfaction" />
                                    <div>
                                        <h3>Instant Gratification</h3>
                                        <p className='light'>Get vouchers instantly for <br></br>last-minute gifts or rewards.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className='py-12' >
                <div className="container">
                    <h2>Most Popular Vouchers</h2>

                    <div className='grid' >

                        <div data-aos="zoom-in" className='grid-item grid-item-1'>
                            <img src={netflix_logo} alt="netflix card" />
                            <div>
                                <h3>Netflix</h3>
                                <p>Stream movies, shows, and originals <br></br>
                                    with a Netflix voucher. Redeem for <br></br> entertainment anytime, anywhere.</p>

                            </div>
                            <button className="home_button_white" onClick={() => window.location.href = "/products?search=Netflix"}>View Vouchers</button>
                        </div>


                        <div data-aos="zoom-in" className='grid-item grid-item-2' >
                            <img src={binance_logo} alt="binance card" />
                            <div>
                                <h3>Binance</h3>
                                <p>Boost your crypto journey with Binance <br></br>
                                    vouchers. Use them to trade, invest, <br></br> or explore services on a top exchange.</p>

                            </div>
                            <button className="home_button_white" onClick={() => window.location.href = "/products?search=Binance"}>View Vouchers</button>
                        </div>



                        <div data-aos="zoom-in" className='grid-item grid-item-3' >
                            <img src={bolt_logo} alt="bolt card"/>
                            <div>
                                <h3>Bolt</h3>
                                <p>Travel smarter with Bolt gift vouchers. Use them <br></br>
                                    to pay for convenient, fast, and affordable rides <br></br>
                                    or deliveries in cities around the world.</p>

                            </div>
                            <button className="home_button_white" onClick={() => window.location.href = "/products?search=Bolt"}>View Vouchers</button>
                        </div>



                        <div data-aos="zoom-in" className='grid-item grid-item-4' >
                            <img src={playstation_logo} alt="playstation card"/>
                            <div>
                                <h3>Playstation</h3>
                                <p>Unlock gaming with PlayStation gift vouchers.<br></br>
                                    Redeem for games, add-ons, subscriptions, <br></br> and exclusive content.</p>

                            </div>
                            <button className="home_button_white" onClick={() => window.location.href = "/products?search=Playstation"}>View Vouchers</button>
                        </div>
                    </div>
                </div>
            </section>



            <section data-aos="fade-up" >
                <div className='hero_footer container bg_purple_light br_25 p-5' >                    <div className='row'>
                    <div className='col-xl-6'>

                        <div data-aos="fade-up">
                            <h2 className='bold' >Get the Giftbox <br></br> App Today!</h2>
                            <p className='mt-2 light' >Discover a world of gifting possibilities with just a tap! Access<br></br>
                                exclusive deals, explore top brands, send and redeem vouchers <br></br>
                                instantly, and manage everything effortlessly—all in one app. <br></br>
                                Wherever you are, the ultimate gifting experience is just a <br></br>
                                download away.</p>
                        </div>

                        <div data-aos="fade-up" className='d-flex gap-4 mt-7 flex-wrap' >

                            <a className='os-button' href='https://apps.apple.com/app/id6514304558' target='_blank'>
                                <img src={appstore} alt="appstore"/>
                                <div className='d-flex flex-column' >
                                    <p className='text-dark' >Get it on</p>
                                    <p className='bold text-dark'  >App Store</p>
                                </div>

                            </a>

                            <a className='os-button' href='https://appgallery.huawei.com/#/app/C112833001' target='_blank'>
                                <img src={huawei}  alt="app gallery" />
                                <div className='d-flex flex-column' >
                                    <p className='text-dark mb-0' >Get it on</p>
                                    <p className='bold text-dark mb-0' >App Gallery</p>
                                </div>
                            </a>


                            <a className='os-button' href='https://app.adjust.com/1j5srcd9' target='_blank'>
                                <img src={apk} alt="android"/>
                                <div className='d-flex flex-column' >
                                    <p className='text-dark' >Get it on</p>
                                    <p className='bold text-dark' >APK Android</p>
                                </div>
                            </a>
                        </div>

                    </div>


                </div>
                </div>
            </section>

            <Footer />
        </>
    )
}
